import styled from 'styled-components';

export const ContainerBlock = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  margin-bottom: 1rem;
  padding: 0.7rem;
  max-width: 100%;
  box-shadow: 0 10px 15px 0 rgba(0, 0, 0 0.05);
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 10px;
`;
